// @flow
import styled, { css } from "styled-components"

export const Flex = styled.div`
  display: flex;
`

export const Spread = styled.div`
  display: flex;
  justify-content: space-between;

  ${p =>
    p.bottom &&
    css`
      align-items: flex-end;
    `}

  ${p =>
    p.middle &&
    css`
      align-items: center;
    `}

  ${p =>
    p.margin &&
    css`
      margin-top: 1rem;
    `}
`



// WEBPACK FOOTER //
// ./src/componentsStyled/Layout/Flex.js